export default "__VITE_ASSET__CE2WPjPA__"